import { useState } from 'react';
import Text from '../../../../assets/styles/Text';
import Ad from '../../../../components/Ad';
import PopUp from '../../../../components/PopUp';
import { useAdsByLocation } from '../../../../hooks/queries/useAds';
import * as styles from './styles';

export default function Bottom() {
  const [show, setShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [otherReason, setOtherReason] = useState('');

  // Hook para buscar anúncios
  const { data: ads = [] } = useAdsByLocation('MODEL');

  const options = [
    { label: 'Perfil falso!', show: false, id: 1 },
    { label: 'Fotos indevidas ou enganosas!', show: false, id: 2 },
    { label: 'Informações falsas!', show: false, id: 3 },
    { label: 'Comportamento abusivo ou desrespeitoso!', show: false, id: 4 },
    { label: 'Menor de idade!', show: false, id: 5 },
    { label: 'Duplicidade de perfil!', show: false, id: 6 },
    { label: 'Tentativa de golpe!', show: false, id: 7 },
    {
      label: 'Outros (ao clicar abrir um campo pra escrever)',
      show: true,
      id: 8,
    },
  ];

  function handleOptionChange(optionId) {
    setSelectedOption(optionId);
    // Limpa o campo "outros" se uma opção diferente for selecionada
    if (optionId !== 6) {
      setOtherReason('');
    }
  }

  function handleSubmit() {
    if (!selectedOption) {
      alert('Por favor, selecione um motivo para a denúncia.');
      return;
    }

    if (selectedOption === 6 && !otherReason.trim()) {
      alert('Por favor, descreva o motivo da denúncia.');
      return;
    }

    // Aqui você pode processar a denúncia
    const reportData = {
      optionId: selectedOption,
      reason:
        selectedOption === 6
          ? otherReason
          : options.find((opt) => opt.id === selectedOption)?.label,
    };

    console.log('Denúncia enviada:', reportData);

    // Resetar o formulário
    setSelectedOption(null);
    setOtherReason('');
    setShow(false);
  }

  function handleClose() {
    setShow(false);
    setSelectedOption(null);
    setOtherReason('');
  }

  return (
    <styles.Container>
      {ads && ads?.map((a) => <Ad key={a.id} img={a.url} link={a.link} />)}

      <styles.Button onClick={() => setShow(true)}>
        Denunciar Este Perfil
      </styles.Button>

      <PopUp show={show} title="Denunciar este perfil!" onClose={handleClose}>
        <styles.Form>
          {options.map((option) => (
            <styles.Bubble
              htmlFor={`radio-${option.id}`}
              key={option.id}
              $checked={selectedOption === option.id}
            >
              <input
                type="radio"
                id={`radio-${option.id}`}
                name="report-reason"
                value={option.id}
                checked={selectedOption === option.id}
                onChange={() => handleOptionChange(option.id)}
                hidden
              />
              <Text.Span>{option.label}</Text.Span>
            </styles.Bubble>
          ))}

          {selectedOption === 6 && (
            <textarea
              placeholder="Descreva o motivo da denúncia..."
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
            />
          )}

          <styles.ButtonContainer>
            <styles.SubmitButton onClick={handleSubmit}>
              <Text.Span $bold>Enviar Denúncia</Text.Span>
            </styles.SubmitButton>

            <styles.CancelButton onClick={handleClose}>
              <Text.Span>Cancelar</Text.Span>
            </styles.CancelButton>
          </styles.ButtonContainer>
        </styles.Form>
      </PopUp>
    </styles.Container>
  );
}
